export default "__VITE_ASSET__TeaF1GOy__"